'use client';

import { PaginationWidget } from '@/widgets';
import { Center, Loader, Table } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import useSWR from 'swr';

const HEADING_TITLES = [
  'Kompaniya nomi',
  'Hudud',
  'Kurslar',
  "O'quvchilar",
  'Bitiruvchilar',
  "Ishga joylashgan bitiruvchilar bo'yicha",
  "Eksport qiluvchi kompaniyaga ishga joylashganlar bo'yicha",
  'Umumiy reyting',
];

type RatingData = {
  data: {
    id: number;
    actual_address: string;
    courses_count_score: number;
    exporter_graduates_count_score: number;
    graduates_count_score: number;
    hired_graduates_count_score: number;
    legal_address: string;
    name: string;
    rating_score: number;
    students_count_score: number;
  }[];
  meta: {
    last_page: number;
  };
};

export function ITParkRating() {
  const t = useTranslations();
  const searchParams = useSearchParams();

  const { data: ratingData, isLoading } = useSWR<RatingData>([
    'https://api.crm.digital.uz/v1/external/centers',
    {
      params: {
        include: 'rating_score,places.region',
        sort: '-rating_score',
        per_page: 15,
        page: searchParams.get('page'),
      },
    },
  ]);

  return isLoading ? (
    <ITParkRatingLoader />
  ) : (
    <>
      <Table.ScrollContainer minWidth={500} pt="lg" type="native">
        <Table
          bg="#eef4fe"
          borderColor="#bed2eb"
          horizontalSpacing="sm"
          verticalSpacing="md"
          style={{ borderRadius: '5px' }}
        >
          <Table.Thead>
            <Table.Tr>
              {HEADING_TITLES.map((title) => (
                <Table.Th key={title}>{t(title)}</Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {ratingData?.data?.map((item) => (
              <Table.Tr key={item?.id}>
                <Table.Td>{item?.name}</Table.Td>
                <Table.Td>{item?.legal_address}</Table.Td>
                <Table.Td>{item?.courses_count_score}</Table.Td>
                <Table.Td>{item?.students_count_score}</Table.Td>
                <Table.Td>{item?.graduates_count_score}</Table.Td>
                <Table.Td>{item?.hired_graduates_count_score}</Table.Td>
                <Table.Td>{item?.exporter_graduates_count_score}</Table.Td>
                <Table.Td>{item?.rating_score}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
      <PaginationWidget totalPage={ratingData?.meta?.last_page} />
    </>
  );
}

export function ITParkRatingLoader() {
  return (
    <Center mih={200}>
      <Loader />
    </Center>
  );
}
